/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_LicenseInputs */

const en_pc_cmp_r_license = /** @type {(inputs: Pc_Cmp_R_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License`)
};

const zh_pc_cmp_r_license = /** @type {(inputs: Pc_Cmp_R_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`许可证`)
};

/**
* | output |
* | --- |
* | "License" |
*
* @param {Pc_Cmp_R_LicenseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_license = /** @type {((inputs?: Pc_Cmp_R_LicenseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_LicenseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_license(inputs)
	return zh_pc_cmp_r_license(inputs)
});
export { pc_cmp_r_license as "pc.cmp.r.license" }